  export function normalizeString(str: string): string {
    return str
      .toUpperCase()
      .normalize('NFD')                  
      .replace(/[\u0300-\u036f]/g, '')  
      .replace(/[-–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }